import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShareService } from '@app/shared/services/vault/share.service';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

import { now } from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@AutoUnsubscribe()
@Component({
  selector: 'add-value-balance-popup',
  templateUrl: './add-value-balance-popup.component.html',
  styleUrls: ['./add-value-balance-popup.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddValueBalancePopupComponent implements OnInit, OnDestroy {
  attributeForm;
  today = new Date();
  subscription = new Subscription();
  constructor(
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
    private shareService: ShareService,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<AddValueBalancePopupComponent>
  ) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.attributeForm = this.formBuilder.group({
      value_num: [
        this.data?.currentValue ?? '',
        [Validators.required, Validators.pattern('^-?([0]{1}.{1}[0-9]+|[1-9]{1}[0-9]*.{1}[0-9]+|[0-9]+|0)$')],
      ],
      effective_date: [new Date().toISOString()],
    });
  }
  closedialog() {
    this.dialogRef.close({
      isSuccess: false,
    });
  }
  private markFormGroupTouched(formGroup: UntypedFormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
  addAttribute() {
    this.markFormGroupTouched(this.attributeForm);
    if (!this.attributeForm.valid || Number(this.attributeForm.get('value_num').value) == 0) {
      return;
    }

    let date = new Date(this.attributeForm.controls.effective_date.value);
    const BALANCE_DETAIL = {
      vault_user_form_id: this.data.currentFormId,
      effective_date: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
      user_id: this.data.currentuserId,
      value: this.attributeForm.controls.value_num.value,
      is_death_benefit: this.data.attributeType == 'death' || this.data.attributeType == 'Benefit' ? true : null,
      is_intrinsic_value: this.data.attributeType == 'intrinsic_value' ? true : null,
    };

    this.subscription.add(
      this.shareService.createBalanceEntry(BALANCE_DETAIL).subscribe(
        (response) => {
          this.toastr.success('Value Added successfully.');
          this.dialogRef.close({
            isSuccess: true,
          });
        },
        (error) => {
          this.toastr.error(error);
        }
      )
    );
  }
  getValue(evt: any) {
    const strFix = `${evt}`.replace(/,/g, '');
    this.attributeForm.controls['value_num'].setValue(strFix);
  }
}
